/**
 * Component to render rich text content using Draft.js.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.text] - The raw Draft.js content state as a JSON string.
 * @returns {JSX.Element} The rendered rich text content.
 */
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import './rich-text.scss'

function RichText({
  className,
  text,
  removeDefaultStyles = false,
}: {
  className?: string
  text?: string
  removeDefaultStyles?: boolean
}): JSX.Element {
  if (!text) {
    return <></>
  }

  try {
    const draftState = EditorState.createWithContent(
      convertFromRaw(JSON.parse(text))
    )

    const textHtml = draftToHtml(convertToRaw(draftState.getCurrentContent()))

    return (
      <div
        className={`${removeDefaultStyles ? '' : 'rich-text-container'} ${
          className ?? ''
        }`}
        dangerouslySetInnerHTML={{ __html: textHtml }}
      />
    )
  } catch {
    return <></>
  }
}

export default RichText
